var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChervonRight = function SvgChervonRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.355 11.855 5.07 6.994.355 2.133a1.275 1.275 0 0 1 0-1.767 1.184 1.184 0 0 1 1.713 0l5.577 5.75a1.275 1.275 0 0 1 0 1.767l-5.577 5.75a1.184 1.184 0 0 1-1.713 0c-.461-.488-.473-1.29 0-1.778"
  })));
};
export default SvgChervonRight;